import PauseSubscription from '@/services/subscriptions/PauseSubscription';
import CancelSubscription from '@/services/subscriptions/CancelSubscription';
import CreateSubscription from '@/services/subscriptions/CreateSubscription';
import ContinueSubscription from '@/services/subscriptions/ContinueSubscription';
import FetchAllSubscriptions from '@/services/subscriptions/FetchAllSubscriptions';
import UpdateSubscriptionPlan from '@/services/subscriptions/UpdateSubscriptionPlan';
import UpdateSubscriptionQuantity from '@/services/subscriptions/UpdateSubscriptionQuantity';
import CreateSubscriptionFromLapsedSubscription from '@/services/subscriptions/CreateSubscriptionFromLapsedSubscription';
import UpdateProductType from '@/services/subscriptions/UpdateProductType';
import CharityPrice from '@/services/subscriptions/CharityPrice';
import PausedUntil from '@/services/subscriptions/PausedUntil';

export default class SubscriptionService {
    cancelSubscription(subscriptionId, reasonId) {
        return (new CancelSubscription()).handle(subscriptionId, reasonId);
    }

    continueSubscription(subscriptionId, payload) {
        return (new ContinueSubscription()).handle(subscriptionId, payload);
    }

    createSubscription(payload) {
        return (new CreateSubscription()).handle(payload);
    }

    createSubscriptionFromLapsedSubscription(payload) {
        return (new CreateSubscriptionFromLapsedSubscription()).handle(payload);
    }

    fetchAllSubscriptions(userId) {
        return (new FetchAllSubscriptions()).handle(userId);
    }

    pauseSubscription(subscriptionId, payload) {
        return (new PauseSubscription()).handle(subscriptionId, payload);
    }

    updateSubscriptionPlan(subscriptionId, plan, date, scheduleChange, restartDate, selectedDeliveryDate) {
        return (new UpdateSubscriptionPlan()).handle(subscriptionId, plan, date, scheduleChange, restartDate, selectedDeliveryDate);
    }

    updateSubscriptionQuantity(subscriptionId, quantity) {
        return (new UpdateSubscriptionQuantity()).handle(subscriptionId, quantity);
    }

    updateProductType(subscriptionId, prodId, name, date) {
        return (new UpdateProductType()).handle(subscriptionId, prodId, name, date);
    }

    charityPrice(subscriptionId, price) {
        return (new CharityPrice()).handle(subscriptionId, price);
    }

    pausedUntil(payload, apiService = null) {
        return (new PausedUntil(apiService)).handle(payload);
    }
}
